import { render, staticRenderFns } from "./ActiveMilitary.vue?vue&type=template&id=4a6bb35c&"
import script from "./ActiveMilitary.vue?vue&type=script&lang=js&"
export * from "./ActiveMilitary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports